const Backbone = require('backbone');
var ShoppingListModel = Backbone.Model.extend({
	urlRoot: function() {
		return `/app/api/shoppinglists/v2/${this.get('projectId')}`;
	},
	api: 'local',
	// Overwrite save function
	save: function(attrs, options) {
		const saveData = Object.assign({}, this.attributes, attrs);
		options = options || {};
		// Filter the data to send to the server to slim payload
		saveData.pending = null;
		saveData.purchased = null;
		saveData.shoppingListSessionCartItems = null;
		options.data = JSON.stringify(saveData);
		options.contentType = 'application/json';
		// Proxy the call to the original save function
		return Backbone.Model.prototype.save.call(this, attrs, options);
	}
});

module.exports = ShoppingListModel;
